import React from "react";
import { Rocket, FileEarmarkText, ExclamationTriangle, Globe } from "react-bootstrap-icons";

const items = [
  { icon: <Rocket />, text: "New UKG customers" },
  { icon: <FileEarmarkText />, text: "Organizations replacing legacy systems" },
  { icon: <ExclamationTriangle />, text: "Companies facing payroll or timekeeping issues" },
  { icon: <Globe />, text: "Growing or multi-region enterprises" },
];

export default function WhoItsFor() {
  return (
    <section className="py-5 text-center">
      <div className="container">
        <h2 className="fw-bold mb-4">Who It's For</h2>
        <div className="row g-4">
          {items.map((it, i) => (
            <div key={i} className="col-md-3">
              <div className="who-card">
                <div className="icon-box">{it.icon}</div>
                <p className="mb-0">{it.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
